
import { useState } from 'react';

export default function BlogCategories() {
  const [activeCategory, setActiveCategory] = useState('All');

  const categories = [
    { name: 'All', count: 24 },
    { name: 'Training Tips', count: 8 },
    { name: 'Youth Development', count: 6 },
    { name: 'Nutrition', count: 4 },
    { name: 'Mental Game', count: 3 },
    { name: 'Equipment', count: 3 }
  ];

  return (
    <section className="py-12 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Browse by Category</h2>
          <p className="text-lg text-gray-600">Find articles that match your interests and development goals</p>
        </div>

        <div className="flex flex-wrap justify-center gap-4">
          {categories.map((category, index) => (
            <button
              key={index}
              onClick={() => setActiveCategory(category.name)}
              className={`px-6 py-3 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                activeCategory === category.name
                  ? 'bg-green-500 text-white'
                  : 'bg-white text-gray-700 hover:bg-green-50 hover:text-green-600 border border-gray-200'
              }`}
            >
              {category.name} ({category.count})
            </button>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-lg p-6 shadow-md">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-trophy-line text-2xl text-green-600 w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Training Tips</h3>
            <p className="text-gray-600 mb-4">Professional coaching advice and proven training methods to improve your skills</p>
            <span className="text-green-600 font-semibold">8 Articles</span>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-md">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-team-line text-2xl text-blue-600 w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Youth Development</h3>
            <p className="text-gray-600 mb-4">Age-appropriate development strategies and milestone guidance for young players</p>
            <span className="text-blue-600 font-semibold">6 Articles</span>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-md">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-brain-line text-2xl text-purple-600 w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Mental Game</h3>
            <p className="text-gray-600 mb-4">Building confidence, focus, and mental resilience on and off the field</p>
            <span className="text-purple-600 font-semibold">3 Articles</span>
          </div>
        </div>
      </div>
    </section>
  );
}
